import { render, staticRenderFns } from "./App.vue?vue&type=template&id=768c70c5"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=768c70c5&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports